import React from 'react';
import { Button, InputNumber } from 'kenshin';

const QuantityInputWrapper = ({
  value,
  onChange,
  isRoot,
  onOpenModal,
  disabledInp,
  placeholder,
  style,
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
      <InputNumber
        value={value}
        onChange={onChange}
        disabled={disabledInp}
        placeholder={placeholder}
        style={{ flex: 1, ...style }}
        stepType="inside"
      />
      {isRoot && disabledInp && (
        <Button type="primary" onClick={onOpenModal} style={{ marginLeft: 8 }}>
          修改数量
        </Button>
      )}
    </div>
  );
};

export default QuantityInputWrapper;
